import { Button } from "antd";
import PropTypes from "prop-types";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Label,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import StatisticsTooltip from "./StatisticsTooltip";
import YAxisLabel from "./StatisticsYAxisLabel";

function StatisticsMonthlyChart({
  waterConsumptionData,
  handleHideMonthlyChart,
}) {
  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      className="bg-triple-white rounded-b-xl pl-1"
    >
      <BarChart data={waterConsumptionData?.StatisticsData}>
        <Button type="primary" size="small" onClick={handleHideMonthlyChart}>
          close
        </Button>
        <CartesianGrid strokeDasharray="1 0" vertical={false} />
        <XAxis dataKey="Day">
          <Label
            content={
              <g>
                <text x="22" y="269">
                  Day
                </text>
              </g>
            }
          />
        </XAxis>
        <YAxis dataKey="WaterConsumption" name="Consumption">
          <Label content={YAxisLabel("m3")} />
        </YAxis>
        <Tooltip
          labelStyle={{ color: "#808080" }}
          content={
            <StatisticsTooltip
              year={waterConsumptionData?.Year}
              payload={waterConsumptionData?.StatisticsData}
              active
              chartType="Monthly"
              label=""
            />
          }
        />
        <Legend verticalAlign="top" align="right" height={40} />
        <Bar
          dataKey="WaterConsumption"
          name="Consumption"
          fill="#03a5d2"
          barSize={20}
          minPointSize={5}
        >
          {waterConsumptionData?.StatisticsData?.map((entry) => (
            <Cell
              fill={entry.WaterConsumption === 0 ? "none" : "#03a5d2"}
              key={entry.Day}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

StatisticsMonthlyChart.defaultProps = {
  waterConsumptionData: {},
  handleHideMonthlyChart: () => {},
};

StatisticsMonthlyChart.propTypes = {
  waterConsumptionData: PropTypes.object,
  handleHideMonthlyChart: PropTypes.func,
};
export default StatisticsMonthlyChart;
